import React from "react";
import { PROCESO } from "../../data/estudio";

const FotoProceso = () => (
  <section id="como-funciona" className="bg-white py-20 md:py-28">
    <div className="container-page">
      <h2 className="section-title max-w-2xl">Tres pasos.</h2>
      <ol className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
        {PROCESO.map((step, index) => (
          <li key={step.title}>
            <p className="font-display text-4xl font-bold tabular-nums text-sand-400">{index + 1}</p>
            <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-navy-900">{step.title}</h3>
            <p className="mt-2 text-[0.95rem] leading-relaxed text-navy-600">{step.copy}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default FotoProceso;
